<template>
    <b-card-body>
        <p class="mt-3">
            Page: {{ pagination.page }} of {{ pageCount }} Total:
            {{ pagination.total }}
        </p>
        <b-row>
            <b-col md="2" cols="12">
                <b-button-group>
                    <b-button
                        variant="light"
                        size="sm"
                        @click="shouldShowFilters = !shouldShowFilters"
                    >
                        <span style="white-space: nowrap">
                            Filters
                            <b-icon
                                :icon="`chevron-${
                                    shouldShowFilters ? 'up' : 'down'
                                }`"
                            ></b-icon>
                        </span>
                    </b-button>
                    <b-button
                        variant="light"
                        size="sm"
                        @click="resetFilters"
                        v-b-tooltip.hover
                        title="Reset Filters"
                    >
                        <b-icon icon="arrow-repeat" variant="dark"></b-icon>
                    </b-button>
                </b-button-group>
            </b-col>

            <b-col class="text-right mb-2">
                <slot></slot>
            </b-col>
        </b-row>

        <RatingQueryFilter
            class="mt-12"
            v-show="shouldShowFilters"
            :officers="officers"
            ref="queryFilter"
            v-model="filters"
            :disabled-officers="!hasPermissionView"
        />

        <b-table :fields="fields" :items="items" :busy="loading">
            <template #cell(id)="row">
                <b-button
                    size="sm"
                    @click="ordersRefRoute(row.item)"
                    class="mr-2"
                    variant="primary"
                >
                    View
                </b-button>
            </template>
            <template #cell(feedback)="row">
                <b-form-rating
                    body-class="p-0 text-left"
                    v-model="row.item.feedback"
                    no-border
                    readonly
                >
                </b-form-rating>
            </template>
            <template #table-busy>
                <div class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong>Loading...</strong>
                </div>
            </template>
        </b-table>
        <b-row>
            <b-col>
                <b-pagination
                    class="float-right"
                    v-model="pagination.page"
                    :total-rows="pagination.total"
                    :per-page="pagination.pageSize"
                    aria-controls="customerTable"
                    pills
                    align="right"
                ></b-pagination>
            </b-col>
        </b-row>
    </b-card-body>
</template>
<script>
const _ = require('lodash')
import popupMixins from '@/mixins/popupMixins'
import reportMixins from '@/mixins/reportMixins'
import RatingQueryFilter from './RatingQueryFilter.vue'
import moment from 'moment'

// import LocationSection from '@/views/Location/LocationSection'
// import CustomerUsers from '@/components/CustomerUsers.vue'
import permissionsMixins from '@/mixins/permissionsMixins'
const defaultFilters = Object.freeze({
    completion_date_from: null,
    completion_date_to: null,
    driver_id: null,
    rating: null,
})

export default {
    name: 'customers-ratinglistitem',
    components: { RatingQueryFilter },
    props: ['title', 'items', 'customer_id'],
    mixins: [popupMixins, reportMixins, permissionsMixins],
    data() {
        return {
            query: '',
            shouldShowFilters: false,
            reportType: 'order_rating_details',
            filters: { ...defaultFilters },
            componentName: 'Customer Rating',
            tabIndex: 0,
            fields: [
                { key: 'id', label: 'Actions' },
                { key: 'reference_no', label: 'Reference Number' },
                {
                    key: 'feedback',
                    label: 'Rating',
                    formatter: (key, value, item) =>
                        item ? item.feedback : 10,
                },
                { key: 'feedback_comments', label: 'Comments' },
                {
                    key: 'driver_id',
                    label: 'Officer',
                    formatter: (value, key, item) => {
                        const { first_name, last_name } = item.driver || {}
                        return `${first_name || ''} ${last_name || ''}`
                    },
                },
                {
                    key: 'driver_id',
                    label: 'Officer',
                    formatter: (value, key, item) => {
                        const { first_name, last_name } = item.driver || {}
                        return `${first_name || ''} ${last_name || ''}`
                    },
                },
                {
                    key: 'completed_at',
                    label: 'Completion Date',
                    formatter: value =>
                        !value ? '' : this.formatDateTime(value), // tk: To be revisited
                },
                {
                    key: 'updated_at',
                    label: 'Time of Comment',
                    formatter: (value, key, item) => {
                        if (item.feedback !== null) {
                            return item.updated_at.split(' ')[1]
                        }
                    },
                },
            ],
            loading: false,
            locationSectionData: {},
            count: 0,
        }
    },
    mounted() {
        if (this.$route.query.query) this.query = this.$route.query.query
        this.doSearch()
    },
    computed: {
        officers() {
            return this.$store.getters['users/sorted_officers']
        },
        pagination() {
            return this.$store.state.orders.pagination || {}
        },
        pageCount() {
            return Math.ceil(this.pagination.total / this.pagination.pageSize)
        },
        ordersRoute() {
            return `/admin/activities/?page=1&query=&customer_id=${this.model.id}&entity=1`
        },
        submitLabel() {
            if (this.loading && this.model.id) {
                return 'Updating...'
            } else if (this.loading) {
                return 'Creating...'
            } else if (this.model.id) {
                return 'Save'
            } else {
                return 'Create'
            }
        },
    },

    watch: {
        report_loading: function (val) {
            this.$emit('report-state', val)
        },
        filters: {
            handler: function (filters) {
                console.log('filters', filters)
                this.doSearch()
            },
            deep: true,
        },
        'pagination.page': function () {
            this.doSearch()
        },
        query: _.debounce(function (query) {
            this.$router.push({ query: { query } })
            this.doSearch()
        }, 200),
    },
    methods: {
        getQueryString(rpt_type) {
            const queryModel = {}
            queryModel.name = this.query
            queryModel.rpt_type = rpt_type
            return `&query=${btoa(JSON.stringify(queryModel))}`
        },
        resetFilters() {
            this.filters = { ...defaultFilters }
            this.doSearch()
        },
        ordersRefRoute(OrderData) {
            this.$router.push(
                `/admin/activities/?page=1&query=${OrderData.reference_no}&customer_id=${this.customer_id}&entity=1`
            )
        },
        formatDateTime(value) {
            const format1 = 'YYYY-MM-DD'
            var date1 = new Date(value)
            return moment(date1).format(format1)
        },
        doSearch() {
            console.log('id', this)
            // const page = 1
            try {
                this.loading = true
                const id = this.id
                let {
                    query,
                    filters,
                    pagination: { page },
                } = this
                page = parseInt(page) || 1
                // this.tableLoading = true
                this.$router.push({
                    query: { query, ...filters },
                })
                this.$store
                    .dispatch('orders/fetch', {
                        query,
                        page,
                        filters,
                        id,
                    })
                    .then(() => {
                        this.loading = false
                    })

                // })
            } catch (err) {
                console.error('loading error', err)
            }
        },
    },
}
</script>
<style></style>
